import { createSelector } from 'reselect'

const desmosSelector = state => state.desmos

const saveSelector = createSelector(
	[desmosSelector],
	desmos => ({
		entityUID: desmos.entityUID,
		categoryID: desmos.category,
		pickID: desmos.selectedGraph,
	})
)

export default saveSelector
